import * as React from 'react';
import classNames from 'classnames';

import { CollapsedBlock } from '../CollapsedBlock';
import * as styles from './styles.css';
import { trackOpenNewbuildingDescription } from './tracking';

interface INewbuildingDescriptionProps {
  description: string;
}

export function NewbuildingDescription({ description }: INewbuildingDescriptionProps) {
  const [opened, setOpened] = React.useState(false);
  const onChangeOpen = React.useCallback(
    (isOpen: boolean) => {
      setOpened(isOpen);
      if (isOpen) {
        trackOpenNewbuildingDescription();
      }
    },
    [setOpened],
  );

  return (
    <CollapsedBlock opened={opened} onChangeOpen={onChangeOpen} collapsedHeight={174}>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description }}
        className={classNames(styles['text'], opened && styles['formatted'])}
      />
    </CollapsedBlock>
  );
}
